export const radioValueToYesNoString = (value: string) => {
  try {
    const number = parseInt(value);
    return Boolean(number) ? "common.yes" : "common.no";
  } catch (err) {
    return "common.no";
  }
};
